import { render, staticRenderFns } from "./ChannelUsersView.vue?vue&type=template&id=2764ea79&"
import script from "./ChannelUsersView.vue?vue&type=script&lang=ts&"
export * from "./ChannelUsersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports